import { createFileRoute, Navigate } from '@tanstack/react-router'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { GHGEmissions } from '@/features/Sustainability/components/GHGEmissions/GHGEmissions'

export const Route = createFileRoute(
    '/_layout/sustainability/ghg-emissions-report'
)({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <GHGEmissions />
            </RoleRestrictedContent>
        </>
    )
}
